import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {SharedStoreFacade} from 'app/main/shared/shared/store/shared-store.facade';
import {filter, take} from 'rxjs';
import {IDocumentTypesDto} from '../../documents/dto/document-listing.dto';
import {TemplateService} from '../templates.service';
import { TemplateType } from '../template.dto';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrl: './filters.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FiltersComponent implements OnInit {
  public templateType: TemplateType;
  public templateTypeEnum = TemplateType;
  @Input() get template_type(): string {
    return this.templateType;
  }
  
  set template_type(value: TemplateType) {
    this.templateType = value || null;
  }
  public readonly = false;
  public searchable = false;
  public selectedDocumentType = null;
  public documentTypes$ = this._sharedStoreFacade.documentTypes$;
  public documentTypes: IDocumentTypesDto[] = [];
  public languages: Array<{id: number, name:string, value:string}> = [
    { id: 0, name: 'All', value: 'all' },
    { id: 1, name: 'English', value: 'english' },
    { id: 2, name: 'Swedish', value: 'swedish' },
    { id: 3, name: 'German', value: 'german' },
    { id: 4, name: 'Finish', value: 'finnish' },
    { id: 5, name: 'French', value: 'french' },
    { id: 7, name: 'Norwegian', value: 'norwegian' },
    { id: 8, name: 'Danish', value: 'danish' },
    { id: 9, name: 'Spanish', value: 'spanish' }
  ];
  public selectedLanguage = 'all';
  public templateTypes: Array<{id: number, name:string, value:string}> = [
    { id: 0, name: this._translocoService$.translate("Filter default selected item - (general) - All"), value: 'all' },
    { id: 1, name: this._translocoService$.translate("Template listing - Signature Request (regular template dropdown text) - Signature Request"), value: 'regular' },
    { id: 2, name: this._translocoService$.translate("Template listing - Document (regular template dropdown text) - Document"), value: 'template_document' },
  ];
  public selectedTemplateType = 'all';

 
  public template_roles = [];
  public submitted = false;
  
  public templateStatus: Array<{id: number, name:string, value:number|string}> = [
    { id: 0, name: this._translocoService$.translate("Filter default selected item - (general) - All"), value: 'all' },
    { id: 1, name: this._translocoService$.translate("Template listing - Template status column (published) - Published"), value: 1 },
    { id: 2, name: this._translocoService$.translate("Template listing - Template status column (draft) - Draft"), value: 0 }
  ]
  public selectedStatus = 'all';

  constructor(
    private templateService: TemplateService,
    private _sharedStoreFacade: SharedStoreFacade,
    private _translocoService$: TranslocoService
  ) { }

  async ngOnInit() {
    this.getDocumenttypes();
  }


  /**
   * update the filter for the template listing
   */
  onFilterChange() {
    this.templateService.onSetFilters({ document_type_id: (this.selectedDocumentType ?? null), language: this.selectedLanguage, template_type: this.selectedTemplateType, status: this.selectedStatus });
  }


  /** Get Document Types */
  getDocumenttypes() {
    this.documentTypes$.pipe(
      filter(result => result?.length > 0),
      take(1)
    ).subscribe(result => {
        // Assign the new array to this.documentTypes
      this.documentTypes = [{
          document_type: this._translocoService$.translate('Filter placeholder (Template filters) - All'),
          id: null,
          user_id: 0,
          workspace_id: 0,
          is_default: false,
          created_at: '',
          updated_at: ''
      }, ...result];
    });
  }

}
